import React from 'react';

function EdgeMarker({ id, color }) {
  return (
    <svg style={{ position: 'absolute', top: 0, left: 0 }}>
      <defs>
        <marker
          className="react-flow__arrowhead"
          id={id}
          markerWidth="10"
          markerHeight="10"
          viewBox="0 0 640 640"
          markerUnits="userSpaceOnUse"
          orient="auto-start-reverse"
          refX="320"
          refY="320"
          fill={color}
        >
          <path d="M441.3 299.8C451.5 312.4 450.8 330.9 439.1 342.6L311.1 470.6C301.9 479.8 288.2 482.5 276.2 477.5C264.2 472.5 256.5 460.9 256.5 448L256.5 192C256.5 179.1 264.3 167.4 276.3 162.4C288.3 157.4 302 160.2 311.2 169.3L439.2 297.3L441.4 299.7z" />
        </marker>
      </defs>
    </svg>
  );
}

export default EdgeMarker;
